module.exports = __webpack_public_path__ + "static/media/friends.f3336d1d.svg";